<template>
	<el-container>
		<Header ref="header"></Header>
		<div class="path-label">商务中心</div>
		<div class="product-root">
			<div @click="changeRoot(0)" :class="active == 0 ? 'product-root-item root-active' : 'product-root-item'">
				<img src="../assets/img/r0.png">
				<div class="product-root-name">优企推荐</div>
			</div>
			<div @click="changeRoot(1)" :class="active == 1 ? 'product-root-item root-active' : 'product-root-item'">
				<img src="../assets/img/r1.png">
				<div class="product-root-name">需求信息</div>
			</div>
			<div @click="changeRoot(index+2)" v-for="(item,index) in $product[0]" :class="active == index+2 ? 'product-root-item root-active' : 'product-root-item'">
				<img :src="icon[index]">
				<el-icon></el-icon>
				<div class="product-root-name">{{item}}</div>
			</div>
		</div>
		<div style="min-height: 80vh;">
			<p0 :current="active" v-if="active==0"/>
			<p1 :current="active" v-if="active==1"/>
			<p2 :current="active" v-if="active==2"/>
			<p3 :current="active" v-if="active==3"/>
			<p4 :current="active" v-if="active==4"/>
			<p5 :current="active" v-if="active==5"/>
			<p6 :current="active" v-if="active==6"/>
			<p7 :current="active" v-if="active==7"/>
			<p8 :current="active" v-if="active==8"/>
			<p9 :current="active" v-if="active==9"/>
			<p10 :current="active" v-if="active==10"/>
			<p11 :current="active" v-if="active==11"/>
			<p12 :current="active" v-if="active==12"/>
		</div>
		<el-backtop>
			<!-- <div style="{height: 100%;width: 100%;background-color: #f2f5f6;box-shadow: 0 0 6px rgba(0,0,0, .12); text-align: center;line-height: 40px;color: #1989fa;}">
				<i class="el-icon-top"></i>
			</div> -->
		</el-backtop>
		<Footer/>
	</el-container>
</template>
<script>
	import Header from '../components/Header.vue'
	import Footer from '../components/footer.vue'
	import {Api} from "../utils/axios.js"
	import p0 from './product/p0.vue'
	import p1 from './product/p1.vue'
	import p2 from './product/p2.vue'
	import p3 from './product/p3.vue'
	import p4 from './product/p4.vue'
	import p5 from './product/p5.vue'
	import p6 from './product/p6.vue'
	import p7 from './product/p7.vue'
	import p8 from './product/p8.vue'
	import p9 from './product/p9.vue'
	import p10 from './product/p10.vue'
	import p11 from './product/p11.vue'
	import p12 from './product/p12.vue'
	export default {
		data(){
			return{
				active:0,
				keywords:'',
				icon:[require('@/assets/img/r2.png'),require('@/assets/img/r3.png'),require('@/assets/img/r4.png'),require('@/assets/img/r5.png'),require('@/assets/img/r6.png'),require('@/assets/img/r7.png'),require('@/assets/img/r8.png'),require('@/assets/img/r9.png'),require('@/assets/img/r10.png'),require('@/assets/img/r11.png'),require('@/assets/img/r12.png')],
			}
		},
		components: {
			p0:p0,p1:p1,p2:p2,p3:p3,p4:p4,p5:p5,p6:p6,p7:p7,p8:p8,p9:p9,p10:p10,p11:p11,p12:p12,Header,Footer
		},
		methods: {
			changeRoot(index){
				this.active = index
			},
			validUser(user){
				if(user.company.state==2){
					return true
				}else{
					return false
				}
			}
		},
		created:function(){
			console.log(sessionStorage.getItem('token'))
			if(sessionStorage.getItem('token')==undefined||sessionStorage.getItem('token')=="undefined"||sessionStorage.getItem('token')==null||sessionStorage.getItem('token')==''){
				this.$parent.showLogin()
				return
			}
			if(sessionStorage.getItem('USERINFO')==null){
				Api('user',{company:sessionStorage.getItem('company')}).then((res) => {
					if(res.code==200){
						sessionStorage.setItem("USERINFO",JSON.stringify(res.result))
						if(this.validUser(res.result)){
							this.active=0
						}else{
							this.$message.error("发布企业及业务信息经审核完成为认证用户后方可使用");
						}
					}else{
						this.$message.error(res.msg);
					}
				})
			}else{
				if(this.validUser(JSON.parse(sessionStorage.getItem('USERINFO')))){
					this.active=0
				}else{
					this.$message.error("发布企业及业务信息经审核完成为认证用户后方可使用");
				}
			}
			console.log()
		}
	}
</script>